import { initSubRoutes } from '../../../../utils/router';

const RoutesGuideCreerCompte = initSubRoutes({
    route: '/aide',
    subroutes: {},
    nom: 'Guide création de compte',
});

export default RoutesGuideCreerCompte;
